/* Original LA012 video: muted inline autoplay with persistent user pause. */

(() => {
  const videos=[...document.querySelectorAll('#la012 video')];
  const reduced=matchMedia('(prefers-reduced-motion: reduce)');
  let userPaused=false;
  const scriptedPause=new WeakSet();
  function pause(video){if(!video.paused){scriptedPause.add(video);video.pause();}}
  function sync(){
    videos.forEach(video=>{
      const eligible=video.getClientRects().length>0&&!document.hidden&&!reduced.matches&&!userPaused;
      video.autoplay=eligible;
      if(!eligible){pause(video);return;}
      if(video.paused)video.play().catch(()=>{video.controls=true;video.setAttribute('aria-label','Evening mask application. Use Play to start video.');});
    });
  }
  videos.forEach(video=>{
    video.muted=true;video.defaultMuted=true;video.playsInline=true;
    video.addEventListener('pause',()=>{if(scriptedPause.has(video)){scriptedPause.delete(video);return;}userPaused=true;});
    video.addEventListener('play',()=>{userPaused=false;video.setAttribute('aria-label','Evening mask application');});
  });
  addEventListener('resize',sync);document.addEventListener('visibilitychange',sync);reduced.addEventListener('change',sync);sync();
})();
